import * as React from "react";
import "./AiLeadsAction.css";
import Button from "@mui/material/Button";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import StyledMenuInput from "../../StyledMenu/Index";
import {
  getConfidenceScore,
  GetLeadsFilterStatsData,
  GetStatsData,
} from "../../../Utils/Utils";
import SearchIcon from "@mui/icons-material/Search";
import { InputBase, Paper, Tooltip } from "@mui/material";
import {
  AI_DECISION_MAKER,
  AI_PATH_VIDEO,
  AI_PROFILE_VIDEO,
  ARCHIVE_VIDEO,
  BRE_VIDEO,
  COMPETITIVE_REPORT,
  CRIE_VIDEO,
  DATA_ENRICH_VIDEO,
  DEEP_SEARCH_VIDEO,
  FAVORITE_CONFIDENCE_SCORE,
  FAVORITES_VIDEO,
  HELP_CENTER_VIDEO,
  LEADS_CONFIDENCE_SCORE,
  ORGANIZATION_DETAIL_CONFIDENCE_SCORE,
  ORGANIZATION_DETAIL_TILE_VIEW,
  PROSPECT_DETAILS_VIDEO,
  PROSPECTS_CONFIDENCE_SCORE,
  PROSPECTS_DETAIL_CONFIDENCE_SCORE,
  PUSH_TO_JOSF_VIDEO,
  REQUEST_UPDATE,
  UNIVERSAL_SEARCH_VIDEO,
} from "../../../Utils/Constants";
import TrainingModal from "../../Training/TrainingModal";
import video from "../../../Assets/video.svg";
import videodash from "../../../Assets/play-button.png";
import {
  COMPETITIVE_INTEL_VIDEO,
  PERSONALIZED_DASHBOARD_VIDEO,
} from "../../../Utils/Constants";
import moment from "moment";
import FavoriteSearch from "../../FavoritesList/FavoritesListSearch/FavoriteSearch";
import FavoritesList from "../../../Pages/FavoriteList/FavoritesList";
import { useLocation } from "react-router-dom";
export default function AiLeadsAction({
  profileData,
  currentLeadsLength,
  setDownloadToPDF,
  setIsSalesForceTrigger,
  isSalesForceTrigger,
  setIsDecisionMakerExcel,
  statsCount,
  statsCountDecisionMaker,
  setArchiveRecord,
  setUnArchivedRecord,
  disableTracking,
  setTrackRecord,
  setAddToFav,
  setRequestUpdateRecord,
  disableRequestUpdate,
  setShareRecord,
  showSalesForce,
  activeList,
  setActiveList,
  setActiveSearch,
  activeSearch,
  setLoading,
  loading,
  setSearchResultOrganization,
  searchResultPeople,
  setFavoriteSearchData,
  setSearchResultPeople,
  setRetrieveData,
  favoriteListMenuShow,
  setIsDecisionMakerExcelList,
  handleListExport,
  selectedOrganizationList,
  selectedProspectList,
  selectedOrganizationData,
  selectedProspectData,
  setheaderSearchData,
  setheaderSearchDataPeople,
  setOverviewPdfModal,
}) {
  const locationState = useLocation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuSalesforce = () => {
    setIsSalesForceTrigger(true);
    setAnchorEl(null);
  };
  const handleMenuDownloadExcel = () => {
    setIsDecisionMakerExcel(true);
    setAnchorEl(null);
  };
  const handleMenuDownloadExcelList = () => {
    setIsDecisionMakerExcelList(true);
    setAnchorEl(null);
  };
  const handleMenuArchiveRecord = () => {
    setArchiveRecord(true);
    setAnchorEl(null);
  };
  const handleMenuUnArchiveRecord = () => {
    setUnArchivedRecord(true);
    setAnchorEl(null);
  };
  const handleMenuTrackRecord = () => {
    setTrackRecord(true);
    setAnchorEl(null);
  };
  const handleMenuAddToFav = () => {
    setAddToFav(true);
    setAnchorEl(null);
  };
  const handleMenuShareRecord = () => {
    setShareRecord(true);
    setAnchorEl(null);
  };
  const handleMenuRequestUpdateRecord = () => {
    setRequestUpdateRecord(true);
    setAnchorEl(null);
  };
  const handleShowBREPdfModal = () => {
    setDownloadToPDF(true);
    setAnchorEl(null);
  };
  const handleAnchoElement = () => {
    setAnchorEl(null);
  };
  React.useEffect(() => {
    if (isSalesForceTrigger) {
      setIsSalesForceTrigger(false);
    }
  }, [isSalesForceTrigger]);
  const location = window?.location?.pathname;
  const statsData = GetStatsData();
  const filterStatsData = GetLeadsFilterStatsData();
  const [videoModal, setVideoModal] = React.useState(false);
  const [overviewVideoModal, setOverviewVideoModal] = React.useState(false);
  const [videoLink, setVideoLink] = React.useState("");
  const handleCloseOverview = () => {
    setOverviewVideoModal(false);
  };
  const handleVideoModal = (item) => {
    setOverviewVideoModal(true);
    if (item === 1) {
      setVideoLink(COMPETITIVE_INTEL_VIDEO);
    } else if (item === 2) {
      setVideoLink(PERSONALIZED_DASHBOARD_VIDEO);
    } else if (item === 3) {
      setVideoLink(ARCHIVE_VIDEO);
    } else if (item === 4) {
      setVideoLink(AI_PROFILE_VIDEO);
    } else if (item === 5) {
      setVideoLink(FAVORITES_VIDEO);
    } else if (item === 6) {
      setVideoLink(PUSH_TO_JOSF_VIDEO);
    } else if (item === 7) {
      setVideoLink(AI_PATH_VIDEO);
    } else if (item === 8) {
      setVideoLink(DATA_ENRICH_VIDEO);
    } else if (item === 9) {
      setVideoLink(PROSPECT_DETAILS_VIDEO);
    } else if (item === 10) {
      setVideoLink(HELP_CENTER_VIDEO);
    } else if (item === 11) {
      setVideoLink(CRIE_VIDEO);
    } else if (item === 12) {
      setVideoLink(UNIVERSAL_SEARCH_VIDEO);
    } else if (item === 13) {
      setVideoLink(LEADS_CONFIDENCE_SCORE);
    } else if (item === 14) {
      setVideoLink(PROSPECTS_CONFIDENCE_SCORE);
    } else if (item === 15) {
      setVideoLink(PROSPECTS_DETAIL_CONFIDENCE_SCORE);
    } else if (item === 16) {
      setVideoLink(ORGANIZATION_DETAIL_CONFIDENCE_SCORE);
    } else if (item === 17) {
      setVideoLink(ORGANIZATION_DETAIL_TILE_VIEW);
    } else if (item === 18) {
      setVideoLink(FAVORITE_CONFIDENCE_SCORE);
    } else if (item === 19) {
      setVideoLink(DEEP_SEARCH_VIDEO);
    } else if (item === 20) {
      setVideoLink(REQUEST_UPDATE);
    } else if (item === 21) {
      setVideoLink(BRE_VIDEO);
    } else if (item === 22) {
      setVideoLink(COMPETITIVE_REPORT);
    }
  };
  const handleProfileDetails = () => {
    setOverviewPdfModal(true);
    setAnchorEl(null);
  };
  return (
    <>
      <section
        className={
          location === "/favoritesList"
            ? "Leades-filter-drop-down-button-main-container-fav"
            : "Leades-filter-drop-down-button-main-container"
        }
      >
        <div
          className={
            location === "/favoritesList" || location === "/bre"
              ? "setProspects-Search-filter-favorite"
              : "setProspects-Search-filter"
          }
        >
          <div
            className={
              location === "/favoritesList"
                ? "showing-leads-head-fav"
                : "showing-leads-head"
            }
          >
            {location === "/Archived" ? <h3>Archived Records</h3> : null}
            {location?.includes("aiprofile") ? <h3>AI Profile</h3> : null}
            {location === "/people-results" ||
            location === "/organization-results" ? (
              <>
                <h3>Search Results</h3>
                <div className="psr-size">
                  {" "}
                  Search Inquiry: {locationState.state}
                </div>
              </>
            ) : null}
            {location?.includes("Profile") ? (
              <div>
                <h3>Prospect Details</h3>

                {/* <div className="data-sync-c-rate">
                    <div className="datasync-line-c-score">
                      <span className="datasync-line">Data Sync: </span  > <span className="datasync-line-data">{profileData?.updated_at ? moment(profileData.updated_at).format("MM.DD.YY") : "No update information available"}</span> </div>
                    <div className="datasync-line-c-score"> <span className="datasync-line">Data Confidence Score:</span>
                      <span className="datasync-line-data">{profileData?.confidence_score ? `${profileData.confidence_score * 10}%` : "No update information available"}</span></div>
                  </div> */}
              </div>
            ) : null}

            {location?.includes("companyprofilescreen") ? (
              <h3>Organization Details</h3>
            ) : null}
            {location === "/bre" ? (
              <h3>Business Retention & Expansion (BRE)</h3>
            ) : null}
            {location === "/favorites" ? <h3>Favorites</h3> : null}
            {location === "/favorites" ? <h3>Favorites</h3> : null}
            {location === "/favoritesList" ? (
              <>
                <div className="fav-my-list-shared">
                  <FavoriteSearch
                    setheaderSearchData={setheaderSearchData}
                    setheaderSearchDataPeople={setheaderSearchDataPeople}
                    setRetrieveData={setRetrieveData}
                    activeList={activeList}
                    setActiveList={setActiveList}
                    setActiveSearch={setActiveSearch}
                    activeSearch={activeSearch}
                    setLoading={setLoading}
                    loading={loading}
                    setSearchResultOrganization={setSearchResultOrganization}
                    setSearchResultPeople={setSearchResultPeople}
                    setFavoriteSearchData={setFavoriteSearchData}
                    searchResultPeople={searchResultPeople}
                  />
                </div>{" "}
              </>
            ) : null}
            {location === "/dataenrich" ? <h3>Data Enrich</h3> : null}
            {currentLeadsLength && !statsCount && location === "/aileads" ? (
              <>
                <h3>
                  Showing {currentLeadsLength}{" "}
                  {location === "/aidecisionmakers" ? "Prospects " : "leads"}
                </h3>
                <p>
                  Out of{" "}
                  {location === "/aileads" || "/aiLeads"
                    ? statsData?.generated_leads.toLocaleString() || "-"
                    : null}
                </p>
              </>
            ) : null}
            {statsCount ? (
              <>
                <h3>
                  Showing {currentLeadsLength}{" "}
                  {location === "/aidecisionmakers" ? "Prospects " : "leads"}
                </h3>
                <p>
                  Out of{" "}
                  {location === "/aileads" || "/aiLeads" ? statsCount : null}
                </p>
              </>
            ) : null}
            {currentLeadsLength &&
            !statsCount &&
            location === "/aidecisionmakers" &&
            !statsCountDecisionMaker ? (
              <>
                <h3>
                  Showing {currentLeadsLength}{" "}
                  {location === "/aidecisionmakers" ? "Prospects " : "leads"}
                </h3>
                <p>
                  Out of{" "}
                  {location === "/aidecisionmakers"
                    ? statsData?.decisionmaker_count.toLocaleString() || "-"
                    : null}
                </p>
              </>
            ) : null}
            {statsCountDecisionMaker ? (
              <>
                <h3>
                  Showing {currentLeadsLength}{" "}
                  {location === "/aidecisionmakers" ? "Prospects " : "leads"}
                </h3>
                <p>
                  Out of{" "}
                  {location === "/aidecisionmakers"
                    ? statsCountDecisionMaker || "-"
                    : null}
                </p>
              </>
            ) : null}
          </div>
          {/* {location === AI_DECISION_MAKER && (
            <Paper className='Ai-Prospect-Serach-data'
              component="form"
              sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
            >
              <SearchIcon className='searchicon-in-header' />
              <InputBase
            
                className='search-inner-text'
                sx={{ ml: 1, flex: 1 }}
                placeholder="by people name"
                inputProps={{ 'aria-label': 'Search google maps' }}
                autoComplete="off"
              />
            </Paper>
          )} */}
        </div>
        <div className="Leades-filter-inner-container video-space-org-details">
          <div
            className="video_container"
            onClick={() => setVideoModal(!videoModal)}
          >
            <img src={video} alt="video" className="videoIcon" />
            {videoModal && (
              <>
                {location === "/aileads" ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(3)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Archive</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(4)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">AI Profile</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>

                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(19)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Deep Search</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(13)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Data Confidence Score
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(5)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Favorites</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(6)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Push to JOSF</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(20)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Request Update</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(12)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Universal Search
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location === "/aidecisionmakers" ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(3)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Archive</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(4)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">AI Profile</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(19)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Deep Search</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(14)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Data Confidence Score
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(5)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Favorites</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(6)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Push to JOSF</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(20)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Request Update</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(12)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Universal Search
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location === "/Archived" ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(3)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Archive</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(18)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Data Confidence Score
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location === "/dataenrich" ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(8)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Data Enrich</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(5)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Favorites</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(12)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Universal Search
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location?.includes("Profile") ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(3)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Archive</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(1)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Competitive Intel
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(15)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Data Confidence Score
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(5)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Favorites</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>

                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(22)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              JOI Competitive Intel PDF Reports
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>

                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(9)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Prospect Details
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(6)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Push to JOSF</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>

                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(20)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Request Update</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(12)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Universal Search
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location === "/favoritesList" ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(5)}
                      >
                        <div className="bell-icon-outer-video">
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Favorites</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>

                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(6)}
                      >
                        <div className="bell-icon-outer-video">
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Push to JOSF</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(20)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Request Update</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(12)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Universal Search
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location?.includes("companyprofilescreen") ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(3)}
                      >
                        <div className="bell-icon-outer-video">
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Archive</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(1)}
                      >
                        <div className="bell-icon-outer-video">
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Competitive Intel
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>

                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(11)}
                      >
                        <div className="bell-icon-outer-video">
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">CRIE</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(5)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Favorites</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>

                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(6)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Push to JOSF</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location?.includes("aiprofile") ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(4)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">AI Profile</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(12)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Universal Search
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location === "/people-results" ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(19)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Deep Search</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location === "/organization-results" ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(19)}
                      >
                        <div className="bell-icon-outer-video">
                          {/* <div className="bell-icon-container-inner"> */}
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          {/* </div> */}
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">Deep Search</p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : location === "/bre" ? (
                  <>
                    <div className="bell-icon-box-video">
                      <div
                        className="bellicons-notification-container video_drop_hover"
                        onClick={() => handleVideoModal(21)}
                      >
                        <div className="bell-icon-outer-video">
                          <img
                            src={videodash}
                            alt="logo"
                            className="video_img_drop"
                          />
                          <div className="bellicon-text">
                            <p className="bellicon-p-search">
                              Business Retention & Expansion (BRE)
                            </p>
                          </div>
                        </div>
                        <div className="bellicon-separator"></div>
                      </div>
                    </div>
                  </>
                ) : null}
              </>
            )}
          </div>
          <Button
            style={{ textTransform: "none" }}
            id="action-button"
            aria-controls={open ? "action-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            variant="contained"
            disableElevation
            onClick={handleMenuClick}
            endIcon={<KeyboardArrowDownIcon />}
          >
            Action
          </Button>
          <StyledMenuInput
            handleMenuDownloadExcelList={handleMenuDownloadExcelList}
            disableTracking={disableTracking}
            handleProfileDetails={handleProfileDetails}
            anchorEl={anchorEl}
            open={open}
            handleAnchoElement={handleAnchoElement}
            handleMenuSalesforce={handleMenuSalesforce}
            handleMenuDownloadExcel={handleMenuDownloadExcel}
            handleMenuArchiveRecord={handleMenuArchiveRecord}
            handleMenuUnArchiveRecord={handleMenuUnArchiveRecord}
            handleMenuTrackRecord={handleMenuTrackRecord}
            handleMenuAddToFav={handleMenuAddToFav}
            handleMenuRequestUpdateRecord={handleMenuRequestUpdateRecord}
            disableRequestUpdate={disableRequestUpdate}
            handleMenuShareRecord={handleMenuShareRecord}
            showSalesForce={showSalesForce}
            favoriteListMenuShow={favoriteListMenuShow}
            handleListExport={handleListExport}
            selectedOrganizationList={selectedOrganizationList}
            selectedProspectList={selectedProspectList}
            selectedOrganizationData={selectedOrganizationData}
            selectedProspectData={selectedProspectData}
            handleShowBREPdfModal={handleShowBREPdfModal}
          />
        </div>
        {/* {
          location?.includes("Profile") ?
            <div>
              <div className="data-sync-c-rate">
                <div className="datasync-line-c-score">
                  <span className="datasync-line">Data Sync: </span  >
                  <span className="datasync-line-data">{profileData?.updated_at ? moment(profileData.updated_at).format("MM.DD.YY") : "No update information available"}</span>
                </div>

                <Tooltip
                  title={
                    "This score reflects a combination of record completeness, freshness, and data source reliability."
                  }
                >
                  <div className="datasync-line-c-score">
                    <span className="datasync-line">Data Confidence Score:</span>
                    <span className="datasync-line-data">{profileData?.confidence_score ? `${Math.round(profileData.confidence_score * 10)}%` : "No update information available"}</span>
                  </div>
                </Tooltip>

              </div>
            </div>
            : null
        } */}
      </section>
      {location?.includes("Profile") ? (
        // <div>
        <div className="data-sync-c-rate">
          <div className="datasync-line-c-score">
            <span className="datasync-line">Data Sync: </span>
            <span className="datasync-line-data">
              {profileData?.updated_at
                ? moment(profileData.updated_at).format("MM.DD.YY")
                : "No update information available"}
            </span>
          </div>

          <div className="datasync-line-c-score">
            <Tooltip
              title={
                "This score reflects a combination of record completeness, freshness, and data source reliability."
              }
            >
              <span>
                <span className="datasync-line">Data Confidence Score:</span>
                <span className="datasync-line-data">
                  {profileData?.confidence_score
                    ? getConfidenceScore(profileData.confidence_score)
                    : "No update information available"}
                </span>
              </span>
            </Tooltip>
          </div>
        </div>
      ) : // </div>
      null}
      <TrainingModal
        overviewVideoModal={overviewVideoModal}
        handleCloseOverview={handleCloseOverview}
        videoLink={videoLink}
      />
    </>
  );
}
